module.exports = __webpack_public_path__ + "img/21_80.ae279863.png";